import styled, { css } from 'styled-components';
import InlineSVG from 'svg-inline-react';

import MarketingPageSection from 'src/app/components/Elements/MarketingPageSection';

export const ListContainer = styled.div<{ toggleShow: boolean; isFullScreen: boolean }>`
  width: 100%;
  margin-top: ${props => props.theme.space.s2};
  ${props => (props.toggleShow ? 'display: block;' : 'display: none;')}
  height: fit-content;
  ${props => props.theme.mediaQueries.smallDown} {
    max-height: calc(100vh - 500px);
    min-height: 100px;
  }
  ${props => props.theme.mediaQueries.small} {
    height: calc(100vh - 260px);
    max-height: 500px;
  }
  overflow: auto;
  z-index: ${({ theme }) => theme.zIndex.z1};
`;

export const ListItem = styled.button`
  background: none;
  font: inherit;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
  color: ${props => props.theme.colors.capsuleGray50};
  padding: ${props => props.theme.space.s3} ${props => props.theme.space.none};
  width: 100%;
  border-top: none;
  border-right: none;
  border-left: none;
  border-bottom: 0;
  z-index: ${({ theme }) => theme.zIndex.z3};
`;

export const ListTextContainer = styled.div`
  color: ${props => props.theme.colors.capsuleGreen60};
  text-align: left;
`;

export const ListText = styled.div`
  font-size: ${props => props.theme.fontSizes.body};
  margin-bottom: ${props => props.theme.space['0.3']};
  line-height: ${props => props.theme.lineHeights.body};
  color: ${props => props.theme.colors.capsuleGreen60};
`;

export const ListSubText = styled.div`
  margin-top: ${props => props.theme.space.s1};
  color: ${props => props.theme.colors.capsuleGray50};
`;

export const PlaceIconContainer = styled.div`
  width: 3rem;
  height: 3rem;
  padding-right: ${props => props.theme.space.s2};
  margin-right: ${props => props.theme.space.s2};
  fill: ${props => props.theme.colors.capsuleBlue90};
  flex: none;
`;

export const PharmacySearchContainer = styled.div<{ isFullScreen: boolean; isMobile: boolean }>`
  ${props =>
    props.isFullScreen && props.isMobile
      ? css`
          position: absolute;
          top: 0;
          left: 0;
          width: 100vw !important;
          background: white;
          padding: ${({ theme }) => theme.space.s7} ${({ theme }) => theme.space.s5};
          z-index: ${({ theme }) => theme.zIndex.z1};
          border-bottom: 100vh solid white;
        `
      : ''}
`;

export const MedInStockTag = styled.div`
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.capsuleGreen60};
  padding: ${({ theme }) => theme.space.s1} ${({ theme }) => theme.space.s2};
  margin-top: ${({ theme }) => theme.space.s2};
  border-radius: ${props => props.theme.radii.r200};
`;

export const CapsuleLogo = styled(InlineSVG)`
  svg {
    height: ${props => props.theme.space.s6};
    margin-bottom: ${props => props.theme.space.s1};
  }
`;

export const StyledMainPageContent = styled(MarketingPageSection)`
  min-height: 100vh;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.capsuleGreen00};
`;
